import { render, staticRenderFns } from "./cnzz.vue?vue&type=template&id=4d89481c&scoped=true"
import script from "./cnzz.vue?vue&type=script&lang=js"
export * from "./cnzz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89481c",
  null
  
)

export default component.exports